// apiConstants.js

export const API_BASE_URL = "https://doc.myassistancenow.com/api/api";
export const FileURL = "https://doc.myassistancenow.com/api";

// export const API_BASE_URL = "http://127.0.0.1:8000/api";
